
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as _91_46_46_46all_93DcA_RHQVlPJpKWiD__KZ_458Qes8AMu1_45XSqY1n2_B_45s4Meta } from "/vercel/path0/pages/[...all].vue?macro=true";
import { default as error500f7s_45Ge_Hv1HMBPX_bxx9QdZVesdzco4P5X8R_45KdX_uwMeta } from "/vercel/path0/pages/error500.vue?macro=true";
import { default as Merchh5wHTJSCdSyAtL6OkQEDeUroKTF1mN8hcD7o6dKQ18QMeta } from "/vercel/path0/pages/Categories/Merch.vue?macro=true";
import { default as TermsOfUseBIwAjHTAOExU9pJCZ3DDK3E9Z7OmkSpoVODY8qgrAZUMeta } from "/vercel/path0/pages/Legal/TermsOfUse.vue?macro=true";
import { default as School5ITVfHmwcE7LQKnIkUhBFGiqiAAa7d9z4C5Ht5fXZ3YMeta } from "/vercel/path0/pages/Categories/School.vue?macro=true";
import { default as StudioiR9GRrRxa4zZw6SE9kVAxmEpaoYWPUDcmmf_45ecV8kSAMeta } from "/vercel/path0/pages/Categories/Studio.vue?macro=true";
import { default as CookiePolicyFBc2IoN0_45ZLjYrILSNdoezUVrLj_45BbPR8_cDsJKzEtYMeta } from "/vercel/path0/pages/Legal/CookiePolicy.vue?macro=true";
import { default as Contacts96vrnc9WCB58hzBDh8qjl9F5DE2hLS_45sKaAgHV1eGuwMeta } from "/vercel/path0/pages/Categories/Contacts.vue?macro=true";
import { default as Projects7TpqTByE1x5Z4FS9OZ1T2__5Uw5F1iRriPtU7gIoeVUMeta } from "/vercel/path0/pages/Categories/Projects.vue?macro=true";
import { default as ServiceslrtKzCU_45zjHIPrWjiTjFtMLZTuSFkGKzg6cmNm7TyCMMeta } from "/vercel/path0/pages/Categories/Services.vue?macro=true";
import { default as PrivacyPolicyTIXNmifIJYXAdcrvADyD_45XIEz9y6uMq2LV3kTLdHR3YMeta } from "/vercel/path0/pages/Legal/PrivacyPolicy.vue?macro=true";
import { default as TermsAndConditions6hkY3kUdRzsaz7cDaklERNDRLaqwo_45xk_45MQiO0OLMOgMeta } from "/vercel/path0/pages/Legal/TermsAndConditions.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "all",
    path: "/:all(.*)*",
    meta: _91_46_46_46all_93DcA_RHQVlPJpKWiD__KZ_458Qes8AMu1_45XSqY1n2_B_45s4Meta || {},
    component: () => import("/vercel/path0/pages/[...all].vue")
  },
  {
    name: "error500",
    path: "/error500",
    meta: error500f7s_45Ge_Hv1HMBPX_bxx9QdZVesdzco4P5X8R_45KdX_uwMeta || {},
    component: () => import("/vercel/path0/pages/error500.vue")
  },
  {
    name: "Categories-Merch",
    path: "/Categories/Merch",
    component: () => import("/vercel/path0/pages/Categories/Merch.vue")
  },
  {
    name: "Legal-TermsOfUse",
    path: "/Legal/TermsOfUse",
    component: () => import("/vercel/path0/pages/Legal/TermsOfUse.vue")
  },
  {
    name: "Categories-School",
    path: "/Categories/School",
    component: () => import("/vercel/path0/pages/Categories/School.vue")
  },
  {
    name: "Categories-Studio",
    path: "/Categories/Studio",
    component: () => import("/vercel/path0/pages/Categories/Studio.vue")
  },
  {
    name: "Legal-CookiePolicy",
    path: "/Legal/CookiePolicy",
    component: () => import("/vercel/path0/pages/Legal/CookiePolicy.vue")
  },
  {
    name: "Categories-Contacts",
    path: "/Categories/Contacts",
    component: () => import("/vercel/path0/pages/Categories/Contacts.vue")
  },
  {
    name: "Categories-Projects",
    path: "/Categories/Projects",
    component: () => import("/vercel/path0/pages/Categories/Projects.vue")
  },
  {
    name: "Categories-Services",
    path: "/Categories/Services",
    component: () => import("/vercel/path0/pages/Categories/Services.vue")
  },
  {
    name: "Legal-PrivacyPolicy",
    path: "/Legal/PrivacyPolicy",
    component: () => import("/vercel/path0/pages/Legal/PrivacyPolicy.vue")
  },
  {
    name: "Legal-TermsAndConditions",
    path: "/Legal/TermsAndConditions",
    component: () => import("/vercel/path0/pages/Legal/TermsAndConditions.vue")
  }
]